import { Dialog } from './Dialog';
import { useOpenClose } from 'core/hooks/useOpenClose';

/** ログアウトのコンポーネント。 */
export const SignOut = () => {
  const { isOpen, handleOpen, handleClose } = useOpenClose();

  return (
    <>
      <button
        className="text-[18px] text-error noto-sans-jp-bold"
        onClick={handleOpen}
      >
        ログアウト
      </button>
      <Dialog open={isOpen} onClose={handleClose} />
    </>
  );
};
